import { HardDrive } from 'lucide-react'

/** Marks audits run on the user's own machine — their scores depend on that machine and network. */
export default function RunLocationBadge({ runLocation }: { runLocation: 'HOSTED' | 'LOCAL' }) {
  if (runLocation !== 'LOCAL') return null
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] bg-white/5 border border-white/10 text-[var(--text-secondary)]"
      title="Scores depend on the machine and network that ran the audit"
    >
      <HardDrive size={11} aria-hidden />
      Ran on your machine
    </span>
  )
}
